






















































































































































































































import Vue from 'vue';
/* globals process */
import {
  MobileMenuTray,
  UserMenu,
} from '@/components/global-components/global-header-component/header-components';

import { EventBus } from '@/event-bus';
import { getContentArea } from '@/contentful';
import { AuthService } from '@/services';

import { dialogMaxWidth } from '@/constants';
import { UserModel } from '@/@types/member';

interface Data {
  menuOpen: boolean;
  someData: number;
  logoUrl: string;
  dialogMaxWidth: string;
  signOutConfirm: boolean;
  learnLink: string;
  clientName: string;
}

export default Vue.extend({
  name: 'GlobalHeader',
  beforeMount() {
    getContentArea(['global-learn-link']).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.learnLink = contentAreas[0].fields.actionValue;
        }
      }
    });
  },
  data(): Data {
    return {
      menuOpen: false,
      someData: 15,
      logoUrl: null,
      dialogMaxWidth,
      signOutConfirm: false,
      learnLink: '',
      clientName: process.env.VUE_APP_CLIENT_NAME,
    };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    unreadNotifications(): number {
      const notifications = this.$store.getters.notifications;

      if (notifications && notifications.length > 0) {
        return this.$store.getters.notifications.filter((notification) => {
          return notification.isReadIndicator === false;
        }).length;
      }

      return 0;
    },
  },
  methods: {
    setMenu(event): void {
      this.menuOpen = event;
    },
    openMobileMenu(): void {
      EventBus.$emit('openMobileMenu');
    },
    logout(): void {
      AuthService.signOutUser(true);
    },
    confirmSignOut(): void {
      this.signOutConfirm = true;
    },
    isRoute(action): boolean {
      return action ? action.indexOf('route="') > -1 : false;
    },
    isLink(action): boolean {
      return action ? action.indexOf('link="') > -1 : false;
    },
    isSelfLink(action): boolean {
      return action ? action.indexOf('link:self="') > -1 : false;
    },
    constructRoute(action): string {
      let regex;
      if (this.isRoute(action)) {
        regex = /(route=")(.*)(")/g;
      } else if (this.isLink(action)) {
        regex = /(link=")(.*)(")/g;
      } else if (this.isSelfLink(action)) {
        regex = /(link:self=")(.*)(")/g;
      }
      return action.replace(regex, (match, a, b) => {
        return b;
      });
    },
  },
  mounted() {
    /**
     * Get the notifications.
     * @event getNotifications
     * @type {action}
     */
    if (this.user.memberId) {
      this.$store.dispatch('getNotifications');
    }
  },
  components: {
    MobileMenuTray,
    UserMenu,
  },
});
